import React from 'react';
import { Card } from '@brokerbay/design-components';
import styled from 'styled-components';

const ContactDetailsCard: React.FC = () => (
  <StyledCard title="Contact Details" withContent={false}>
    {/* Contact details content will go here */}
  </StyledCard>
);

export default ContactDetailsCard;

export const StyledCard = styled(Card)<{ withContent?: boolean }>`
  ${({ withContent }) =>
    withContent &&
    `.ant-card-body {
    padding: 1px 0px;
  }`}
`;
